module.exports = __webpack_public_path__ + "img/check.9eebcc30.svg";